<template>
    <div id="app">
        <router-view @jwt="setJWT" @role="setRole"  />
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                jwt: ""
            }
        },
        methods: {
            setJWT(status) {
                this.jwt = status;
            },
            setRole(status) {
                this.role = status;
            }
        }
    }
</script>

<style>
    html, body {
        background-color: #F0F0F0;
        width: 100%;
        margin: auto;
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 0px;
    }
    html{
        height: 100%;
    }
    #app {
        width: 100%;
        margin: auto;
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 0px;
    }
</style>